import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import { githubProjectsData } from '../data/githubProjectsData';

const GithubProjects = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section id="github-projects" className="container" ref={ref} style={{ padding: '50px 0' }}>
      <h2 className="section-title">
        Live Github <span className="text-gradient">Projects</span>
      </h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
        {githubProjectsData.slice(0, 6).map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ delay: index * 0.15, duration: 0.6 }}
            whileHover={{ y: -10, boxShadow: '0 10px 30px rgba(138,43,226,0.2)' }}
            className="glass-panel"
            style={{ padding: '2rem', display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>{project.title}</h3>
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, flexGrow: 1, marginBottom: '1.5rem' }}>{project.shortDesc}</p>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '1.5rem' }}>
              {project.tech.slice(0, 4).map((t, i) => (
                <span key={i} style={{ fontSize: '0.8rem', color: 'var(--accent-cyan)', background: 'rgba(0,240,255,0.05)', padding: '4px 10px', borderRadius: '12px' }}>
                  {t}
                </span>
              ))}
              {project.tech.length > 4 && (
                <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', padding: '4px 10px' }}>+{project.tech.length - 4} more</span>
              )}
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Link to={`/project/${project.id}`} style={{ display: 'inline-flex', alignItems: 'center', color: '#fff', fontSize: '0.9rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', textDecoration: 'none' }}>
                View Project <span style={{ marginLeft: '8px', color: 'var(--accent-purple)' }}>→</span>
                </Link>
                <a href={project.link} target="_blank" rel="noreferrer" style={{ fontSize: '0.8rem', color: 'var(--accent-cyan)', textDecoration: 'none' }}>Live Demo ↗</a>
            </div>
          </motion.div>
        ))}
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/github-projects" className="contact-btn" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
          View All 12 Github Projects <span style={{ fontSize: '1.2rem' }}>→</span>
        </Link>
      </div>
    </section>
  );
};

export default GithubProjects;
